
Directives.MobileBannerDirective = function MobileBannerDirective() {

    // @ngInject
    function MobileBannerDirectiveControllerFunc($scope, $injector, PopupMessageService, UsersManager,
                                                 AnalyticsService, UserService) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'MobileBannerDirectiveController';

        this.PopupMessageService = PopupMessageService;
        this.UsersManager = UsersManager;
        this.UserService = UserService;
        this.AnalyticsService = AnalyticsService;
        this.currUser = UsersManager.getCurrUser();
        this.phone = "";
        if (this.currUser.phone_number) {
            this.phone = this.currUser.phone_number;
        } else if (this.currUser.company) {
            this.phone = this.currUser.company.phone_number;
        }

        this.AnalyticsService.track(this, "load", {unique: "sms_me_link_to_download",source: "settings_panel"});
    }

    var MobileBannerDirectiveController = Class(Controllers.BaseController, {
        constructor: MobileBannerDirectiveControllerFunc,

        onSubmit: function onSubmit() {
            this.UserService.sendSMSToUser(this.phone);
        }
    });

    return {
        scope: {
        },
        templateUrl: 'angular/app/modules/common/ui_components/mobile/banner/mobile_banner_template.html',
        controller: MobileBannerDirectiveController,
        controllerAs: 'mobileBannerVm',
        bindToController: true
    };
};

